import { createFileRoute } from '@tanstack/react-router';
import WorkReportPublicPage from '@/pages/work-report-public';

/**
 * Documento del rapportino per il cliente, aperto dal link dell'email:
 * rotta pubblica fuori da `/protected`, l'accesso lo dà il token nel path.
 * Il percorso è `WORK_REPORT_PUBLIC_PATH` di `@repo/utils`.
 */
export const Route = createFileRoute('/d/wr/$token')({
  component: WorkReportPublicRoute,
});

function WorkReportPublicRoute() {
  const { token } = Route.useParams();
  return <WorkReportPublicPage token={token} />;
}
